export const ROUTE_LOGIN = { path: "/v3/login" };
export const ROUTE_OPTIONS = { path: "/v3/options" };
export const ROUTE_SETTINGS = { path: "/v3/settings" };
export const ROUTE_SALES = { path: "/v3/sales" };
export const ROUTE_SALES_DETAILS = { path: "/v3/sales_details" };
export const ROUTE_LOCATION = { path: '/v3/location' };
export const ROUTE_LOCATION_DETAILS = { path: '/v3/location_details' };
export const ROUTE_PURCHASES = { path: "/v3/purchases" };
export const ROUTE_PURCHASES_DETAILS = { path: "/v3/purchases_details" };
export const ROUTE_INTERNAL = { path: "/v3/internal" };
export const ROUTE_INTERNAL_DETAILS = { path: "/v3/internal_details" };
export const ROUTE_INVENTORY = { path: "/v3/inventory" };
export const ROUTE_INVENTORY_DETAILS = { path: "/v3/inventory_details" };
export const ROUTE_SCANNER = { path: "/v3/scanner" };
export const ROUTE_SCANNER_DETAILS = { path: "/v3/scanner_details" };
export const ROUTE_COMPLETION = { path: "/v3/completion" };
export const ROUTE_PRODUCT_INFO = { path: "/v3/product" };
export const ROUTE_ASSEMBLY = { path: "/v3/assembly" };
export const ROUTE_ASSEMBLY_DETAILS = { path: "/v3/assembly_details" };
export const ROUTE_COMPANIES = { path: "/v3/companies" };
export const ROUTE_DEPARTMENTS = { path: "/v3/departments" };
export const ROUTE_ERROR = { path: "/error" };
